import React from "react";
import { PageFooterHyperlink } from "./page-footer-hyperlink";
import logoMark from "../assets/logo-mark.png";

export const PageFooter = () => {
  return (
    <footer className="page-footer">
      <div className="page-footer-grid">
        <div className="page-footer-grid__brand">
          <div className="page-footer-brand">
            <PageFooterHyperlink path="/">
              <>
                <img
                  className="page-footer-brand__logo"
                  src={logoMark}
                  alt="Strongifier Logo"
                />
                <span className="page-footer-brand__wordmark">STRONGIFIER</span>
              </>
            </PageFooterHyperlink>
          </div>
        </div>
      </div>
    </footer>
  );
};
